import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { CheckoutPaymentSmartpayCardPage } from 'src/app/modals/checkout-payment-smartpay/checkout-payment-smartpay.page';

const routes: Routes = [
  {
    path: '',
    component: CheckoutPaymentSmartpayCardPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [CheckoutPaymentSmartpayCardPage]
})
export class CheckoutPaymentSmartpayCardPageModule {}
